import { removeInvalidOptions } from '../../field-viewer/shared-normalizers';
export const challengesMultiChoiceViewer = {
    normalizeLoadedValue: removeInvalidOptions
};

//# sourceMappingURL=definition-viewer.js.map